export enum EReactionType {
  LIKE = 'like',
  SMILE = 'smile',
  HEART = 'heart',
}
